import { 
  BrowserRouter as Router, 
  Routes, 
  Route, 
  Outlet
} from "react-router-dom"

import { HeroUIProvider } from "@heroui/react"

import {
  AttendanceReport,
  AuditLog,
  AutoLogin,
  CommentsReport,
  ComingSoon,
  Dashboard,
  Feedback,
  Guardians,
  Home,
  Imports,
  Lessons,
  Login,
  ManageBookings,
  ManageGroups,
  ManageInvitations,
  ManageNotifications,
  ManageTimetable,
  NavigationBridge,
  NetworkError,
  PageNotFound,
  ParentBookingsReport,
  ProtectedRoutes,
  SessionExpired,
  SiteSettings,
  Staff,
  StaffSchedule,
  Students,
  Subjects,
  TawkWidget,
  TeacherBookingsReport,
  Verify,
} from "@components"

import {
  ContextualSidebarContextProvider,
  ModalContextProvider,
  NotificationContextProvider,
  SidebarContextProvider,
  ThemeProvider,
  UserContextProvider,
} from "@context"

import "./App.css"

function App() {  
  return (
    <HeroUIProvider>
      <ThemeProvider>
        <ContextualSidebarContextProvider>
          <NotificationContextProvider>
            <Router>
              <NavigationBridge />
              <SidebarContextProvider>
                <ModalContextProvider>
                  <Routes>
                    <Route element={
                      <UserContextProvider>
                        <TawkWidget />
                        <Outlet />
                      </UserContextProvider>
                    }>
                      {/* Staff and Admin */}
                      <Route element={<ProtectedRoutes />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/coming-soon" element={<ComingSoon />} />
                        <Route path="/feedback" element={<Feedback />} />
                        <Route path="/event/:event/schedule" element={<StaffSchedule />} />
                        <Route path="/verify" element={<Verify />} />
                      </Route>

                      {/* Admin Only */}
                      <Route element={<ProtectedRoutes admin />}>
                        <Route path="/data/guardians" element={<Guardians />} />
                        <Route path="/data/lessons" element={<Lessons />} />
                        <Route path="/settings" element={<SiteSettings />} />
                        <Route path="/data/staff" element={<Staff />} />
                        <Route path="/data/students" element={<Students />} />
                        <Route path="/data/subjects" element={<Subjects />} />
                        <Route path="/data/imports" element={<Imports />} />
                        <Route path="/event/:event/audit-log" element={<AuditLog />} />
                        <Route path="/event/:event/dashboard" element={<Dashboard />} />
                        <Route path="/event/:event/bookings" element={<ManageBookings />} />
                        <Route path="/event/:event/groups" element={<ManageGroups />} />
                        <Route path="/event/:event/invitations" element={<ManageInvitations />} />
                        <Route path="/event/:event/communications" element={<ManageNotifications />} />
                        <Route path="/event/:event/overview" element={<ManageTimetable />} />
                      </Route>

                      <Route element={<ProtectedRoutes reports />}>
                        <Route path="/event/:event/reports/attendance" element={<AttendanceReport />} />
                        <Route path="/event/:event/reports/comments" element={<CommentsReport />} />
                        <Route path="/event/:event/reports/parent-bookings" element={<ParentBookingsReport />} />
                        <Route path="/event/:event/reports/teacher-bookings" element={<TeacherBookingsReport />} />
                      </Route>
                    </Route>

                    <Route path="/login" element={<Login />} />
                    <Route path="/auth/:details" element={<AutoLogin />} />
                    <Route path="/session-expired" element={<SessionExpired />} />
                    <Route path="/404" element={<PageNotFound />} />
                    <Route path="/network-error" element={<NetworkError />} />
                    <Route path="*" element={<PageNotFound />} />
                  </Routes>
                </ModalContextProvider>
              </SidebarContextProvider>
            </Router>
          </NotificationContextProvider>
        </ContextualSidebarContextProvider>
      </ThemeProvider>
    </HeroUIProvider>
  )
}

export default App
